import script from "./ForgotPasswordPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ForgotPasswordPage.vue?vue&type=script&setup=true&lang=js"

import "./ForgotPasswordPage.vue?vue&type=style&index=0&id=4aa058ee&lang=scss"

const __exports__ = script;

export default __exports__